import { Injectable } from '@angular/core';
import { RestApiService } from '../shared/rest-api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CrossStudyService {

  endpoint: string = 'cross-study';
  period!: string;
  //curriculumPeriod = environment.curriculumPeriod; //pituus
  queryParam!: string; //= '?period=2022-2024';

  constructor( //public globals: Globals,
    private api: RestApiService
    ){ 
      //this.globals.schoolYearChanged.subscribe(year => this.onPeriodChange(year)); 
    }

  getOrganisations(): Observable<any[]> {
    return this.api.getList(this.endpoint + '/organisations/');
  }

  getCrossStudyNetworks(id: string): Observable<any[]> {
    return this.api.getList(this.endpoint + '/networks/' + id);
  }

  getCoursesByCrossStudyNetworks(id: string): Observable<any[]> {
    return this.api.getList(this.endpoint + '/networks/' + id + '/courses');
  }



}

